import React, { ReactNode, useEffect, useState } from 'react';

import { IoMdClose } from 'react-icons/io';
import ReactDOM from 'react-dom';

import { useTheme } from 'styled-components';
import { IconButton } from '@mui/material';

import {
  Header,
  ModalContainer,
  Overlay,
  StyCloseContent,
  StyHeaderAling,
  StyModalContent,
} from './styles';
import { Typography } from '../Typography';

interface IModal {
  id: string;
  isOpen: boolean;
  onClose(): void;
  mustCustomClose?: boolean;
  hasCloseButton?: boolean;
  title: string;
  iconTitle?: ReactNode;
  children?: ReactNode;
  width?: string;
  height?: string;
  maxHeight?: string;
  infoModal?: any;
  justifyContent?: string;
  isSmallGapPadding?: boolean;
}

export const Modal2: React.FC<IModal> = ({
  id,
  isOpen,
  onClose,
  title,
  iconTitle,
  children,
  width,
  height,
  maxHeight,
  infoModal,
  justifyContent = 'center',
  isSmallGapPadding = true,
  mustCustomClose = false,
  hasCloseButton = true,
}) => {
  const theme = useTheme();
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 500);
  };

  useEffect(() => {
    mustCustomClose && handleClose();
  }, [mustCustomClose]);

  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    isOpen &&
    ReactDOM.createPortal(
      <Overlay id={id} isClosing={isClosing}>
        <ModalContainer
          isClosing={isClosing}
          width={width}
          height={height}
          maxHeight={maxHeight}
        >
          <Header $isSmallGapPadding={isSmallGapPadding}>
            <StyHeaderAling>
              {!!iconTitle && iconTitle}
              <Typography.Label size="medium" color="neutral.1000">
                {title}
              </Typography.Label>
            </StyHeaderAling>
            <StyCloseContent>
              {infoModal}
              {hasCloseButton && (
                <IconButton onClick={handleClose}>
                  <IoMdClose size={20} color={theme.neutral[1000]} />
                </IconButton>
              )}
            </StyCloseContent>
          </Header>
          <StyModalContent
            justifyContent={justifyContent}
            $isSmallGapPadding={isSmallGapPadding}
          >
            {children}
          </StyModalContent>
        </ModalContainer>
      </Overlay>,
      document.getElementById('portal-root') as HTMLElement
    )
  );
};
